'use client';

import NextLink from 'next/link';
import { useLocale, useTranslations } from 'next-intl';
import { getPathname, usePathname } from '@/i18n/navigation';
import { routing } from '@/i18n/routing';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const LABEL: Record<string, string> = { ru: 'RU', en: 'EN' };

export function LocaleSwitcher() {
  const active = useLocale();
  const t = useTranslations('LocaleSwitcher');
  // Путь уже без префикса локали — та же страница открывается в другом языке.
  const pathname = usePathname();
  const other = routing.locales.find((locale) => locale !== active) ?? active;

  return (
    <NextLink
      // Не Link из i18n/navigation: с явной локалью он префиксует и русский путь.
      href={getPathname({ href: pathname, locale: other })}
      hrefLang={other}
      lang={active}
      aria-label={t(active)}
      title={t('title')}
      className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }), 'text-sm font-medium')}
    >
      {LABEL[other]}
    </NextLink>
  );
}
